import { IPartnerProfile } from '@/models/partners.model';
import { TaxCodeTypes, TPartnerFormValues } from './types';

export const getPartnerFormInitialValues = (partner?: IPartnerProfile | null) => {
  const isLegacyIpn = partner?.organization_tax_type === TaxCodeTypes.IPN;
  const primaryBankAccount = partner?.bank_accounts?.[0];

  return {
    ...partner,

    companyDraft: {
      ownership: partner?.ownership_form ?? undefined,
      vatPayer: partner?.is_vat_payer ?? undefined,
      drfo: partner?.drfo ?? '',
    },
    organization_tax_code: partner?.edrpou ?? (isLegacyIpn ? '' : partner?.organization_tax_code ?? ''),
    ipn: partner?.ipn ?? (isLegacyIpn ? partner?.organization_tax_code ?? '' : ''),
    bank_name: primaryBankAccount?.bank_name ?? partner?.bank_name ?? '',
    iban: primaryBankAccount?.iban ?? partner?.iban ?? '',
    bankAccountsDraft: {
      primaryMfo: primaryBankAccount?.mfo ?? '',
    },
    accountantDraft: {
      noAccountant: partner ? partner.has_no_accountant ?? undefined : false,
      firstName: partner?.accountant_first_name ?? '',
      lastName: partner?.accountant_last_name ?? '',
      middleName: partner?.accountant_middle_name ?? '',
      email: partner?.accountant_email ?? '',
      phone: partner?.accountant_phone ?? '',
    },
    category_manager_id: partner?.category_manager?.id,
  };
};

export const haveAddressesChanged = (values: Partial<TPartnerFormValues>, partner?: IPartnerProfile | null) =>
  (values.legal_address ?? '') !== (partner?.legal_address ?? '') ||
  (values.physical_address ?? '') !== (partner?.physical_address ?? '');
